export default __webpack_public_path__ + "static/media/bar_icon_white.5c7c4675.svg";